/* Storefront views only. Checkout/cart/purchase events are installed separately. */
(function (w, d) {
  'use strict';
  if (w.__smarketOpenAIPixel || (w.Shopify && w.Shopify.designMode)) return;
  var node = d.getElementById('smarket-openai-pixel-config');
  if (!node) return;
  var config;
  try { config = JSON.parse(node.textContent); } catch (_) { return; }
  if (!config.pixelId) return;
  var state = w.__smarketOpenAIPixel = { version: 1, initialized: false, consent: false, viewsSent: false };
  var owned = false;
  function allowed() {
    var p = w.Shopify && w.Shopify.customerPrivacy;
    try {
      return !!p && p.analyticsProcessingAllowed() === true && p.marketingAllowed() === true && p.saleOfDataAllowed() === true;
    } catch (_) { return false; }
  }
  function sync() {
    state.consent = allowed();
    if (!state.consent) {
      if (owned && w.oaiq) w.oaiq('consent', false);
      return;
    }
    if (!state.initialized) {
      // Do not silently duplicate or reconfigure an unknown existing integration.
      if (w.oaiq) { state.conflict = true; return; }
      var q = function () { q.q.push(arguments); }; q.q = []; w.oaiq = q; owned = true;
      q('consent', false);
      q('init', { pixelId: config.pixelId, debug: false });
      var js = d.createElement('script'); js.async = true;
      js.src = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';
      js.onerror = function () { state.sdkLoadError = true; };
      d.head.appendChild(js);
      state.initialized = true;
    }
    w.oaiq('consent', true);
    if (state.viewsSent) return;
    state.viewsSent = true;
    var id = w.crypto && w.crypto.randomUUID ? w.crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2);
    w.oaiq('measure', 'page_viewed', { type: 'contents' }, { event_id: 'smk_page_' + id, opt_out: true });
    if (config.productId) {
      w.oaiq('measure', 'contents_viewed', {
        type: 'contents', contents: [{ id: String(config.productId), content_type: 'product' }]
      }, { event_id: 'smk_product_' + id, opt_out: true });
    }
  }
  d.addEventListener('visitorConsentCollected', sync);
  function ready() {
    if (w.Shopify && w.Shopify.customerPrivacy) { sync(); return; }
    if (w.Shopify && typeof w.Shopify.loadFeatures === 'function') {
      w.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error) sync(); else state.privacyLoadError = true;
      });
    } else { state.privacyUnavailable = true; }
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
})(window, document);
